/*!
 *
 *========================================================
 * Vision UI Free React - custom Chip styles (glassmorphism)
 *========================================================
 *
 */
 
// Base
import colors from "assets/theme/base/colors";
import borders from "assets/theme/base/borders";
import boxShadows from "assets/theme/base/boxShadows";

// Functions
import pxToRem from "assets/theme/functions/pxToRem";
import rgba from "assets/theme/functions/rgba";

const { white, text, gradients, info, error, success, primary } = colors;
const { borderRadius } = borders;
const { md: shadowMd } = boxShadows;

export default {
  defaultProps: {
    size: "medium",
    variant: "filled",
  },
  styleOverrides: {
    root: {
      color: white.main,
      // Glassmorphism base
      background: "rgba(255, 255, 255, 0.06)",
      border: `1px solid ${rgba(white.main, 0.18)}`,
      boxShadow: `0 ${pxToRem(4)} ${pxToRem(20)} ${rgba(0, 0, 0, 0.15)}`,
      backdropFilter: "blur(10px)",
      WebkitBackdropFilter: "blur(10px)",
      borderRadius: borderRadius.lg,
      transition: "all 200ms ease-in-out",
      // Align with current compact UI
      height: pxToRem(28),
      "& .MuiChip-label": {
        paddingLeft: pxToRem(10),
        paddingRight: pxToRem(10),
        fontWeight: 700,
        letterSpacing: 0.3,
      },
      "& .MuiChip-icon": {
        color: white.main,
        marginInlineStart: pxToRem(4),
      },
      "&.MuiChip-clickable:hover": {
        background: "rgba(255, 255, 255, 0.12)",
        transform: "translateY(-1px)",
        boxShadow: shadowMd,
      },
      "&.Mui-disabled": {
        opacity: 0.5,
        pointerEvents: "none",
      },
    },

    // Small size used in lists
    sizeSmall: {
      height: pxToRem(22),
      "& .MuiChip-label": {
        fontSize: pxToRem(10),
        paddingLeft: pxToRem(8),
        paddingRight: pxToRem(8),
      },
      "& .MuiChip-icon": {
        fontSize: pxToRem(14),
        marginInlineStart: pxToRem(2),
      },
    },

    // Color accents (when using color prop)
    colorInfo: {
      background: `linear-gradient(${colors.gradients.info.main}, ${colors.gradients.info.state})`,
      border: `1px solid ${rgba(white.main, 0.18)}`,
    },
    colorError: {
      background: `linear-gradient(${colors.gradients.error.main}, ${colors.gradients.error.state})`,
      border: `1px solid ${rgba(white.main, 0.18)}`,
    },
    colorSuccess: {
      background: `linear-gradient(${colors.gradients.success.main}, ${colors.gradients.success.state})`,
      border: `1px solid ${rgba(white.main, 0.18)}`,
    },
    colorPrimary: {
      background: `linear-gradient(${colors.gradients.primary.main}, ${colors.gradients.primary.state})`,
      border: `1px solid ${rgba(white.main, 0.18)}`,
    },

    // Label
    label: {
      color: white.main,
      lineHeight: 1,
    },
  },
};



